import script from "./SingleSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./SingleSelect.vue?vue&type=script&lang=ts&setup=true"

import "./SingleSelect.vue?vue&type=style&index=0&id=04738f5a&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04738f5a"]])

export default __exports__